// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { useAppDispatch, useAppSelector } from "app/hooks";
import Logo from "assets/images/svg/logo.svg";
import logo_user from "assets/images/svg/user.svg";
import Button from "components/Common/Button";
import { selectConfig } from "features/config/configReducer";
import { emptyTokenType } from "features/config/types";
import { selectEvent } from "features/event/eventReducer";
import { defaultDate } from "features/event/types";
import { connect as connectAction, disconnect as disconnectAction } from "features/wallet/connect";
import { selectWallet } from "features/wallet/walletReducer";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { truncateEthAddress } from "services/utils";
import styled from "styled-components";

const HeaderTag = styled.header``;
// backdrop-filter: blur(12px);

const Header: React.FC = () => {
  const dispatch = useAppDispatch();

  const wallet = useAppSelector(selectWallet);
  const config = useAppSelector(selectConfig);
  const event = useAppSelector(selectEvent);
  const [filter, setFilter] = useState(false);

  const [showMore, setShowMore] = useState<boolean>(false);

  const connect = async () => {
    dispatch(connectAction(emptyTokenType));
  };

  const handeleDisconnect = async () => {
    dispatch(disconnectAction());
    setShowMore(false);
  };

  useEffect(() => {
    if (showMore) {
      document.addEventListener("click", () => {
        setShowMore(false);
      });
    }
  }, [showMore]);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      // console.log("Change...", window.scrollY);
      if (window.scrollY > 40) {
        setFilter(true);
      } else {
        setFilter(false);
      }
    });
  }, []);

  const notice =
    config.base.NOTICE || event.isEnded
      ? "This event has ended. Follow our channels for the upcoming events."
      : !event.isStarted && event.startTime !== defaultDate
      ? "The event hasn't started yet! Follow our channels for more information."
      : "";

  return (
    <HeaderTag className={`${filter && "backdrop-blur-md"} fixed z-20 top-0 w-full `}>
      {notice && (
        <div
          className="fewcha--notice text-center font-bold text-white py-4"
          dangerouslySetInnerHTML={{ __html: notice }}
        />
      )}
      <div className="flex justify-between items-center py-7 max-w-[1232px] mx-auto w-full px-6 xl:px-0">
        <Link
          to="/"
          onClick={() => {
            if (window.pageYOffset > 0) {
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }
          }}
        >
          <img src={Logo} alt="Fewcha Logo" />
        </Link>
        <div className="flex gap-x-4 md:gap-x-7 items-center text-white">
          <div className="flex items-center gap-4 md:gap-8">
            <p
              className="hidden md:block hover:cursor-pointer hover:text-rarely-100"
              title="Membership Perks"
              onClick={() => {
                const benefitEl = (window as any).document.getElementById("benefit");
                // (window as any).scrollTo(0, benefitEl.offsetTop - 80);
                (window as any).scrollTo({ top: Math.floor(benefitEl.offsetTop - 80) });
              }}
            >
              Membership Perks
            </p>
            {config.socials.map((social) => (
              <a key={social.name} href={social.url} target="_blank" rel="noreferrer" className="hover:cursor-pointer">
                <img src={social.icon} alt={social.name} title={social.name} />
              </a>
            ))}
          </div>

          {!wallet.isConnected && (
            <Button onClick={connect} loading={wallet.loading} size="large">
              Connect
            </Button>
          )}

          {wallet.isConnected && (
            <div
              className="flex gap-3 cursor-pointer select-none items-center"
              onClick={(e) => {
                setShowMore((prev) => !prev);
                e.stopPropagation();
              }}
            >
              <div className="pl-5 hidden md:block">
                <div className="text-[22px]">{truncateEthAddress(wallet.address)}</div>
              </div>
              <div className="relative">
                <img src={logo_user} alt="User" className="hover:cursor-pointer" />
                {showMore && (
                  <div
                    className="more absolute  -right-[10px] top-[40px] rounded-md px-4 py-3 min-w-[200px] bg-gray-200 text-black"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {/* <div className="mb-2">
                      Balance: <strong className="px-1">{wallet.balance}</strong>
                      APT
                    </div> */}
                    <div className="md:hidden">
                      Address:
                      <code className="pl-1">{truncateEthAddress(wallet.address)}</code>
                    </div>
                    <button onClick={handeleDisconnect} className="text-red-500 hover:bg-red-100 w-full py-1">
                      Disconnect
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </HeaderTag>
  );
};

export default Header;
